import React from 'react'
import '../../assets/css/CustomStyle.css'
import Logo from '../../assets/images/black-logo.png'
import { Link } from 'react-router-dom'


export default function Footer() {
    return (
        <div className='1440:py-[5rem] 999:py-[3.8rem] 768:py-[2.9rem] py-[25px] section-padding section-primary-bg primary-text 600:flex grid grid-cols-1 items-start justify-start 1350:gap-[27.25rem] 999:gap-[18rem] 768:gap-[10rem] gap-[25px]'>
            {/* logo  */}
            <div className='flex items-start 600:justify-between justify-start gap-[25px]'>
                <div>
                    <Link to='/'>
                        <div className='w-[150px]'>
                            <img loading="lazy" src={Logo} alt='Logo' />
                        </div>
                    </Link>
                    <ul className='1350:pt-[1.875rem] pt-[20px] 1350:pb-[80px] pb-[2.5rem] flex items-center justify-start gap-[.9375rem]'>
                        <li>
                            <Link to='facebook.com' className='group'>
                                <svg className='group-hover:scale-110 transition-all duration-300' width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15.6978" r="15" fill="#D19F80" />
                                    <path d="M17.0796 11.2444H18.3329V9.12436C17.7261 9.06126 17.1164 9.0301 16.5063 9.03103C14.6929 9.03103 13.4529 10.1377 13.4529 12.1644V13.911H11.4062V16.2844H13.4529V22.3644H15.9062V16.2844H17.9462L18.2529 13.911H15.9062V12.3977C15.9062 11.6977 16.0929 11.2444 17.0796 11.2444Z" fill="white" />
                                </svg>
                            </Link>
                        </li>
                        <li>
                            <Link to='linkedin.com' className='group'>
                                <svg className='group-hover:scale-110 transition-all duration-300' width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15.6978" r="15" fill="#D19F80" />
                                    <path d="M21.306 17.4931V22.4124H18.454V17.8224C18.454 16.6691 18.0413 15.8824 17.0093 15.8824C16.2213 15.8824 15.752 16.4131 15.546 16.9258C15.4707 17.1091 15.4513 17.3644 15.4513 17.6211V22.4124H12.598C12.598 22.4124 12.6367 14.6391 12.598 13.8331H15.4513V15.0491L15.4327 15.0771H15.4513V15.0491C15.83 14.4658 16.5067 13.6318 18.022 13.6318C19.8987 13.6318 21.306 14.8584 21.306 17.4931ZM9.614 9.69775C8.63867 9.69775 8 10.3378 8 11.1798C8 12.0031 8.62 12.6624 9.57667 12.6624H9.59533C10.5907 12.6624 11.2087 12.0031 11.2087 11.1798C11.1913 10.3378 10.5907 9.69775 9.614 9.69775ZM8.16933 22.4124H11.0213V13.8331H8.16933V22.4124Z" fill="white" />
                                </svg>
                            </Link>
                        </li>
                        <li>
                            <Link to='https://twitter.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJsYW5nIjoiZW4ifQ%3D%3D%22%7D' className='group'>
                                <svg className='group-hover:scale-110 transition-all duration-300' width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15.6978" r="15" fill="#D19F80" />
                                    <path d="M21.973 11.6978C21.4597 11.9312 20.9064 12.0845 20.333 12.1578C20.9197 11.8045 21.373 11.2445 21.5864 10.5712C21.033 10.9045 20.4197 11.1378 19.773 11.2712C19.2464 10.6978 18.5064 10.3645 17.6664 10.3645C16.0997 10.3645 14.8197 11.6445 14.8197 13.2245C14.8197 13.4512 14.8464 13.6712 14.893 13.8778C12.5197 13.7578 10.4064 12.6178 8.9997 10.8912C8.75303 11.3112 8.61303 11.8045 8.61303 12.3245C8.61303 13.3178 9.11303 14.1978 9.88637 14.6978C9.41303 14.6978 8.97303 14.5645 8.58637 14.3645V14.3845C8.58637 15.7712 9.57303 16.9312 10.8797 17.1912C10.4602 17.306 10.0198 17.3219 9.59303 17.2378C9.7741 17.8062 10.1287 18.3034 10.607 18.6598C11.0854 19.0161 11.6633 19.2136 12.2597 19.2245C11.2488 20.0248 9.9957 20.4574 8.70637 20.4512C8.4797 20.4512 8.25303 20.4378 8.02637 20.4112C9.29303 21.2245 10.7997 21.6978 12.413 21.6978C17.6664 21.6978 20.553 17.3378 20.553 13.5578C20.553 13.4312 20.553 13.3112 20.5464 13.1845C21.1064 12.7845 21.5864 12.2778 21.973 11.6978Z" fill="white" />
                                </svg>
                            </Link>
                        </li>
                        <li>
                            <Link to="https://www.youtube.com/" className='group'>
                                <svg className='group-hover:scale-110 transition-all duration-300' width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15.6978" r="15" fill="#D19F80" />
                                    <path d="M13.6663 17.6977L17.1263 15.6977L13.6663 13.6977V17.6977ZM21.373 12.4777C21.4597 12.791 21.5197 13.211 21.5597 13.7443C21.6063 14.2777 21.6263 14.7377 21.6263 15.1377L21.6663 15.6977C21.6663 17.1577 21.5597 18.231 21.373 18.9177C21.2063 19.5177 20.8197 19.9043 20.2197 20.071C19.9063 20.1577 19.333 20.2177 18.453 20.2577C17.5863 20.3043 16.793 20.3243 16.0597 20.3243L14.9997 20.3643C12.2063 20.3643 10.4663 20.2577 9.77967 20.071C9.17967 19.9043 8.79301 19.5177 8.62634 18.9177C8.53967 18.6043 8.47967 18.1843 8.43967 17.651C8.39301 17.1177 8.37301 16.6577 8.37301 16.2577L8.33301 15.6977C8.33301 14.2377 8.43967 13.1643 8.62634 12.4777C8.79301 11.8777 9.17967 11.491 9.77967 11.3243C10.093 11.2377 10.6663 11.1777 11.5463 11.1377C12.413 11.091 13.2063 11.071 13.9397 11.071L14.9997 11.031C17.793 11.031 19.533 11.1377 20.2197 11.3243C20.8197 11.491 21.2063 11.8777 21.373 12.4777Z" fill="white" />
                                </svg>
                            </Link>
                        </li>
                    </ul>
                    <Link className='text-[1rem] font-[450]'>Copyright  Toromail  2023</Link>
                </div>

                <div className='600:hidden block'>
                    <div className=''>
                        <p className='text-[1.125rem] font-medium 1350:pb-[25px] pb-[20px]'>Company</p>
                        <ul className='space-y-[20px]'>
                            <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                                <Link to='/about'>
                                    About us
                                </Link>
                            </li>
                            <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                                <Link to='Plan'>
                                    Plan
                                </Link>
                            </li>
                            <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                                <Link to='Billing'>
                                    Billing
                                </Link>
                            </li>
                            <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                                <Link to='/integration'>
                                    Integrations
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className='flex items-start 600:justify-between justify-start gap-[25px] 600:w-[650px] '>
                <div className='w-1/3 600:block hidden'>
                    <p className='text-[1.125rem] font-medium 1350:pb-[25px] pb-[20px]'>Company</p>
                    <ul className='space-y-[20px]'>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/about'>
                                About us
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='Plan'>
                                Plan
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='Billing'>
                                Billing
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/integration'>
                                Integrations
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className='600:w-1/3'>
                    <p className='text-[1.125rem] font-medium 1350:pb-[25px] pb-[20px]'>Resources</p>
                    <ul className='space-y-[20px]'>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/affiliate'>
                                Affiliate Program
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/blog'>
                                Blog
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/caseStudies'>
                                Case Studies
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className='600:w-1/3'>
                    <p className='text-[1.125rem] font-medium 1350:pb-[25px] pb-[20px]'>Support</p>
                    <ul className='space-y-[20px]'>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/Key'>
                                Forgot License key
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/help'>
                                Help
                            </Link>
                        </li>
                        <li className='text-[1rem] font-light transition-all duration-300 hover:translate-x-2 '>
                            <Link to='/Releases'>
                                Releases
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
